/* src/app/components/doc-viewer-new/doc-viewer-bottom-panel/doc-viewer-co-pilot/doc-viewer-co-pilot.component.scss */
:host-context(.dark-theme) .prompt-input {
  background: #202020;
}
:host-context(.dark-theme) .prompt-input .prompt-textarea {
  color: white;
}
.prompt-input {
  display: flex;
  position: relative;
  flex-grow: 1;
  border: 2px solid #595959;
  border-radius: 2px;
  margin: 10px 25px;
  padding-right: 0;
}
.prompt-input .prompt-textarea {
  min-height: 21px;
  width: calc(100% - 95px);
  background: transparent;
  border: none;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  padding: 12px 0px 12px 12px;
  outline: none;
}
.prompt-input .prompt-enter {
  z-index: 100;
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding-right: 20px;
  display: flex;
  gap: 10px;
  color: #595959;
  align-items: center;
  height: 100%;
}
.prompt-input .prompt-enter span {
  color: #595959;
}
.prompt-input .prompt-enter i {
  color: #595959;
}
.prompt-enter-button:not(:disabled) i {
  color: rgb(36, 62, 144) !important;
}
button {
  border: unset;
  cursor: pointer;
  background: inherit;
}
.center-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding-bottom: 10px;
}
.prompt-item {
  padding: 5px 0px 5px 16px;
  height: auto;
  cursor: default;
}
.co-pilot-button {
  background-color: #E4E4E4;
  color: #000;
}
.continue-button {
  background-color: #3949AB;
  color: white;
}
.warning-hint {
  color: rgb(63, 81, 181) !important;
  display: flex;
  font-size: 10px;
  margin-left: 25px;
  margin-right: 25px;
  align-items: center;
}
.error-hint {
  color: #f44336 !important;
  display: flex;
  font-size: 10px;
  margin-left: 25px;
  margin-right: 25px;
  align-items: center;
}
.hint-icon {
  font-size: 11px !important;
  align-items: center;
  justify-content: center;
  display: flex;
}
:host-context(.dark-theme) .co-pilot-button {
  background-color: #000;
  color: #FFC107;
}
:host-context(.dark-theme) .continue-button {
  background-color: #000;
  color: #FFC107;
}
:host-context(.dark-theme) .warning-hint {
  color: #ffc107 !important;
}
:host-context(.dark-theme) .prompt-enter-button:not(:disabled) i {
  color: #ffc107 !important;
}
::ng-deep ::-webkit-scrollbar {
  height: 8px;
  width: 15px;
}
::ng-deep ::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: rgb(36, 62, 144);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme ::-webkit-scrollbar {
  height: 12px;
  width: 15px;
}
::ng-deep .dark-theme ::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: #ffc107;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep .dark-theme ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme ::-webkit-scrollbar-corner {
  background: #000;
}
.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #ffc107;
  color: #ffc107;
  box-shadow: 9999px 0 0 -5px;
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;
}
.dot-pulse::before,
.dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #ffc107;
  color: #ffc107;
}
.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px;
  animation: dot-pulse-before 1.5s infinite linear;
  animation-delay: 0s;
}
.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px;
  animation: dot-pulse-after 1.5s infinite linear;
  animation-delay: 0.5s;
}
@keyframes dot-pulse-before {
  0% {
    box-shadow: 9984px 0 0 -5px;
  }
  30% {
    box-shadow: 9984px 0 0 2px;
  }
  60%, 100% {
    box-shadow: 9984px 0 0 -5px;
  }
}
@keyframes dot-pulse {
  0% {
    box-shadow: 9999px 0 0 -5px;
  }
  30% {
    box-shadow: 9999px 0 0 2px;
  }
  60%, 100% {
    box-shadow: 9999px 0 0 -5px;
  }
}
@keyframes dot-pulse-after {
  0% {
    box-shadow: 10014px 0 0 -5px;
  }
  30% {
    box-shadow: 10014px 0 0 2px;
  }
  60%, 100% {
    box-shadow: 10014px 0 0 -5px;
  }
}
/*# sourceMappingURL=doc-viewer-co-pilot.component.css.map */
